import { Switch } from '@/components/ui/switch'
import { useFestiveStore } from '@/stores/useFestiveStore'
import { driver } from 'driver.js'
import { useEffect, useState } from 'react'

const FestiveSwitch = () => {
    const { isFestiveEnabled, setFestiveEnabled } = useFestiveStore()
    const [outdated] = useState(() => new Date() > new Date('2025-12-27'))

    useEffect(() => {
        if (outdated) {
            setFestiveEnabled(false)
            localStorage.removeItem('festive-guide-shown')
        }
    }, [outdated, setFestiveEnabled])

    useEffect(() => {
        if (outdated) return
        const hasSeenGuide = localStorage.getItem('festive-guide-shown')

        if (!hasSeenGuide) {
            setFestiveEnabled(true)

            const timer = setTimeout(() => {
                const driverInstance = driver({
                    showButtons: ['close'],
                    steps: [
                        {
                            element: '#festive-switch-container',
                            popover: {
                                title: '🎄 Mới!',
                                description:
                                    'Hiệu ứng tuyết rơi đã có! Bạn có thể bật/tắt tại đây.',
                                side: 'bottom',
                                align: 'center',
                            },
                        },
                    ],
                    onDestroyed: () => {
                        localStorage.setItem('festive-guide-shown', 'true')
                    },
                })

                driverInstance.drive()
            }, 1000)

            return () => clearTimeout(timer)
        }
    }, [outdated])

    if (outdated) return null

    return (
        <div
            id="festive-switch-container"
            className="flex items-center gap-2 hidden md:flex"
        >
            <span className="text-sm font-medium text-gray-700">
                Let it snow
            </span>
            <Switch
                className="w-8 h-4 [&_span]:h-3 [&_span]:w-3 [&_span]:data-[state=checked]:translate-x-4"
                checked={isFestiveEnabled}
                onCheckedChange={setFestiveEnabled}
            />
        </div>
    )
}

export default FestiveSwitch
